import { MGPFallible } from '@everyboard/lib';
import { MoveWithTwoCoords } from '../../../jscaip/MoveWithTwoCoords';
import { TaflMove } from '../TaflMove';
export class HnefataflMove extends TaflMove {
    static encoder = MoveWithTwoCoords.getFallibleEncoder(HnefataflMove.from);
    static from(start, end) {
        const validity = TaflMove.isValidDirection(start, end);
        if (validity.isFailure()) {
            return validity.toOtherFallible();
        }
        else {
            return MGPFallible.success(new HnefataflMove(start, end));
        }
    }
    getMaximalDistance() {
        return 11;
    }
}
